<!-- HEADER -->
<app-header></app-header>
<!-- <app-menu></app-menu> -->

<div class="page-content">
	<router-outlet></router-outlet>
</div>

<!-- FOOTER -->
<app-footer></app-footer>